import React, { useEffect, useState } from 'react'
import { customer_attributes } from '../../services/dwhservices';
import { buyerKPIsColorCoding } from './ColorCoding';

const BuyerEngagement = ({ glid, setTopProductsList }) => {

    const [buyerData, setBuyerData] = useState([
        { id: 1, leftTitle: "BS Conflict Tickets", leftValue: "0/0", rightTitle: "Buy Lead 30 D", rightValue: 0 },
        { id: 2, leftTitle: "Enquiry Sent", leftValue: 0, rightTitle: "Calls Made", rightValue: 0 },
    ]);

    const buyerEngagementKPIs = async () => {
        try {
            let res = await customer_attributes(glid, 1);
            if(res){
                res = res.data;
                if (res.status_code === 200) {
                    res = JSON.parse(res.response)
                    if (res.cust_attr.length > 0) {
                        const data = res.cust_attr[0];
                        const buyerEngamentData = [
                            { id: 1, leftTitle: "BS Conflict Tickets", leftValue: `${data?.wip_tickets || 0}/${data?.total_tickets || 0}`, rightTitle: "Buy Lead 30 D", rightValue: `${data?.total_bl || 0}` },
                            { id: 2, leftTitle: "Enquiry Sent", leftValue: `${data?.enq_count || 0}`, rightTitle: "Calls Made", rightValue: `${data?.calls_count || 0}` },
                        ]
                        if(data?.top_mcats){ // handling top_mcats values as null.
                            const topMCats = JSON.parse(data?.top_mcats);
                            setBuyerData(buyerEngamentData);
                            buyerTopMCATsList(topMCats)
                        }
                    }
                }
            }
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    }

    const buyerTopMCATsList = (topMcats) => {
        const objectsArray = Object.values(topMcats);
        const nameCounts = objectsArray.reduce((acc, obj) => {
            const name = obj.glcat_mcat_name;
            if (name) {
                acc[name] = (acc[name] || 0) + 1;
            }
            return acc;
        }, {});

        const multipleNamesString = Object.keys(nameCounts)
            .filter(name => nameCounts[name] > 0)
            .join(', ');
        setTopProductsList(multipleNamesString);
    }

    useEffect(() => {
        buyerEngagementKPIs();
    }, [])

    // Grid for showing BuyerEnagement KPIs
    const Item = ({ leftTitle, leftValue, rightTitle, rightValue }) => {
        return (
            <div className="bg-bottom d-flex align-items-center">
                <div className="col-6">
                    <div className="d-flex align-items-center" style={{ height: '43px' }}>
                        <div className="col-8">
                            <h3>{leftTitle}</h3>
                        </div>
                        <div className="col-4">
                            <span style={{'color':`${buyerKPIsColorCoding(leftTitle, leftValue)}` }}>{leftValue}</span>
                        </div>
                    </div>
                </div>
                <div className="col-6 ps-3 bg-left">
                    <div className="d-flex align-items-center" style={{ height: '43px' }}>
                        <div className="col-9">
                            <h3>{rightTitle}</h3>
                        </div>
                        <div className="col-3">
                            <span >{rightValue}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="col-4 h-100 ps-3">
                <div className="table-box">
                    {buyerData.map(item => (
                        <Item
                            key={item.id}
                            leftTitle={item.leftTitle}
                            leftValue={item.leftValue}
                            rightTitle={item.rightTitle}
                            rightValue={item.rightValue}
                        />
                    ))}
                </div>
            </div>
        </>
    )
}

export default BuyerEngagement;